<template>
  <div :class="$style.txt">
    <i18n v-if="path" :path="path" tag="span">
      <template #sender>
        <strong>
          <Avatar :size="20" :user="message.sender" /> {{ senderFullName }}
        </strong>
      </template>
      <template #user>
        <strong>
          <Avatar :size="20" :user="user" /> {{ userFullName }}
        </strong>
      </template>
    </i18n>
    <template v-else>{{ defaultMessage }}</template>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { REASON_CODE, REASON_NAME } from '@/models/Message'
import { mapGetters } from 'vuex'
import { getUserFullName } from '@/helpers'
import Avatar from '@/components/Avatar'

export default {
  name: 'message-content-service',
  components: { Avatar },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({ findUser: 'entities/users/find' }),
    path () {
      const reasonCode = this.message.payload.reason
      const reason = REASON_NAME[reasonCode]
      return reason ? `message.service.${reason}` : ''
    },
    senderFullName () {
      return getUserFullName(this.message.sender)
    },
    user () {
      const reasonCode = this.message.payload.reason
      if (reasonCode === 2 || reasonCode === 3) {
        return this.findUser(this.message.payload.subjectId)
      }
      return null
    },
    userFullName () {
      const reasonCode = this.message.payload.reason
      if (reasonCode === 2 || reasonCode === 3) {
        return getUserFullName(this.user)
      }
      return ''
    },
    defaultMessage () {
      const reasonCode = this.message.payload.reason
      const reason = REASON_NAME[reasonCode]
      return reason ? '' : JSON.stringify(this.message.payload)
    }
  }
}
</script>

<style module lang="scss">
.txt {
  font-weight: 300;
  strong,
  & > span {
    align-items: center;
    display: inline-flex;
  }
  strong {
    font-weight: 600;
    gap: 3px;
  }
  & > span {
    gap: 5px;
  }
}
</style>
